type Point = {
  x: number;
  y: number;
};

interface JSONSerializable {
  toJSON(): Object;
  toString(): string;
}

export class Vector2D implements JSONSerializable {
  x: number;
  y: number;

  static create({ x, y }: Point) {
    return new Vector2D({ x, y });
  }

  constructor(point?: Point) {
    this.x = point?.x || 0;
    this.y = point?.y || 0;
  }

  add(vector: Vector2D) {
    return new Vector2D({ x: this.x + vector.x, y: this.y + vector.y });
  }

  subtract(vector: Vector2D) {
    return new Vector2D({ x: this.x - vector.x, y: this.y - vector.y });
  }

  multiply(scalar: number) {
    return new Vector2D({ x: this.x * scalar, y: this.y * scalar });
  }

  divide(scalar: number) {
    return new Vector2D({ x: this.x / scalar, y: this.y / scalar });
  }

  magnitude() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }

  normalize() {
    return this.divide(this.magnitude());
  }

  dot(vector: Vector2D) {
    return this.x * vector.x + this.y * vector.y;
  }

  angle(vector: Vector2D) {
    return Math.acos(
      this.dot(vector) / (this.magnitude() * vector.magnitude())
    );
  }

  toComponents() {
    return { x: this.x, y: this.y };
  }

  toJSON() {
    return this.toComponents();
  }

  toString() {
    return JSON.stringify(this.toJSON());
  }
}
